// extracted by mini-css-extract-plugin
export default {"container":"nK-z","topReviewHeading":"oK-z","criticalReview":"pK-z","favorableReview":"qK-z","vsSeparator":"rK-z"};